import React from 'react'
import { css } from '@emotion/react'

import WebBrowserIcon from '../../assets/icons/web-browser.inline.svg'
import WindowsIcon from '../../assets/icons/windows.inline.svg'
import MacIcon from '../../assets/icons/mac-os.inline.svg'
import AppleIcon from '../../assets/icons/apple.inline.svg'
import AndroidIcon from '../../assets/icons/android.inline.svg'

const productDomain = process.env.GATSBY_PRODUCT_WEBSITE_URL_FOR_FOOTER

const mainLabelCss = css({
  fontSize: '16px',
  fontWeight: '500',
})

const appsCss = (theme) =>
  css({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '48px',

    '> div': {
      flexBasis: 'calc(100%/6)',
      display: 'flex',
      color: theme.colors.black,
      alignItems: 'center',

      '> a': {
        color: theme.colors.black,

        ':hover': {
          textDecoration: 'underline',
        },
      },

      '> span': {
        marginBottom: '-4px',
      },

      '> svg': {
        marginRight: '8px',
      },
    },

    '> a': {
      flexBasis: 'calc(100%/6)',
      display: 'flex',
      color: theme.colors.black,
      alignItems: 'center',

      '> span': {
        fontSize: '14px',
      },

      '> svg': {
        marginRight: '8px',
      },

      ':hover': {
        textDecoration: 'underline',
      },
    },

    '@media (max-width: 1035px)': {
      display: 'grid',
      gridTemplateRows: 'repeat(2, 1fr)',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gridGap: '30px',
    },

    '@media (max-width: 400px)': {
      gridTemplateRows: 'repeat(3, 1fr)',
      gridTemplateColumns: 'repeat(2, 1fr)',
    },

    '@media (max-width: 390px)': {
      width: '100%',
    },
  })

const appleCss = css({
  fontSize: '14px',

  '.divider': {
    margin: '0 2px',
  },
})

const Apps = () => {
  return (
    <div css={appsCss}>
      <div>
        <span css={mainLabelCss}>Get LiveChat App</span>
      </div>
      <a href={`${productDomain}/app/livechat-web-app/`}>
        <WebBrowserIcon />
        <span>Web Browser</span>
      </a>
      <a href={`${productDomain}/app/livechat-for-windows/`}>
        <WindowsIcon />
        <span>Windows</span>
      </a>
      <a href={`${productDomain}/app/livechat-for-mac/`}>
        <MacIcon />
        <span>macOS</span>
      </a>
      <div css={appleCss}>
        <AppleIcon />
        <a href={`${productDomain}/app/livechat-web-app/`}>iPad</a>
        <span className="divider">|</span>
        <a href={`${productDomain}/app/livechat-for-iphone/`}>iPhone</a>
      </div>
      <a href={`${productDomain}/app/livechat-for-android/`}>
        <AndroidIcon />
        <span>Android</span>
      </a>
    </div>
  )
}

export default Apps
